import React from 'react';
import cx from 'classnames';

import { Badge, IconText, TickIcon } from '@motorway/mw-highway-code';
import { filterDataProps } from '@motorway/mw-highway-code/src/utils/helpers';

import { RecommendedPhotoTipsProps } from './RecommendedPhotoTips.types';

import styles from './RecommendedPhotoTips.module.scss';

export const RecommendedPhotoTips = ({
  badgeText = 'Recommended',
  showBorder,
  tips,
  title = 'Tips for a high quality photo',
  ...rest
}: RecommendedPhotoTipsProps) => (
  <section aria-labelledby="recommended-photo-tips-title" className={cx(styles.recommendedPhotoTips, {
    [styles.recommendedPhotoTipsBorder]: showBorder,
  })} {...filterDataProps(rest)}>
    {badgeText && <div className={styles.badgeContainer}>
      <Badge
        text={badgeText}
        variant="primary"
        weight="bold"
      />
    </div>}
    <h5 className={styles.title} id="recommended-photo-tips-title">
      {title}
    </h5>
    <ul className={styles.content}>
      {tips.map((tip) => (
        <li key={`${tip.recommendationTitle}-${tip.recommendation}`} className={styles.contentItem}>
          <IconText icon={tip.icon ?? TickIcon} text={tip.recommendationTitle} variant="small--heading6" />
          <p className={styles.recommendation}>{tip.recommendation}</p>
        </li>
      ))}
    </ul>
  </section>
);
